<template>
  <v-card>
    <v-simple-table dense>
      <thead>
        <tr style="background-color: rgb(235 244 246)">
          <th class="primary--text">
            {{ $i18n.t("Payment Date") }}
          </th>
          <th class="primary--text">{{ $i18n.t("Payment Mode") }}</th>
          <th class="primary--text">{{ $i18n.t("Amount Paid") }}</th>
          <th class="primary--text">{{ $i18n.t("Settled") }}</th>
          <th class="primary--text">{{ $i18n.t("Status") }}</th>
          <th class="primary--text">{{ $i18n.t("Reference No.") }}</th>
          <th class="text-right primary--text"></th>
        </tr>
      </thead>

      <tbody v-if="payments">
        <tr v-for="(payment, index) in payments" :key="index">
          <td>{{ formatDate(payment.date) }}</td>
          <td>{{ payment.paymentMode }}</td>
          <td>{{ payment.totalAmount }}</td>
          <td>{{ payment.tripUsed }}</td>
          <td>{{ payment.statusStr }}</td>
          <td>{{ payment.refNo }}</td>
          <td>
            <z-confirm-button
              v-show="payment.showDelete"
              class="float-right"
              color="red lighten-1"
              x-small
              fab
              text
              :loading="loading"
              :message="$i18n.t('Do you want to delete this Payment ?')"
              @click="deletePayment(payment._id)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </z-confirm-button>

            <z-payment-done-create
              color="blue"
              style="float: right"
              x-small
              :paymentEdit_id="payment._id"
              :hideBills="true"
              :vendor_id="payment.vendor_id"
              :entity_id="payment.entity_id"
              :expense="expense"
              :singlePage="true"
              btn
              @reload="reload"
            >
              <v-btn color="cyan" text fab x-small>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </z-payment-done-create>
          </td>
        </tr>
      </tbody>
      <tfoot
        v-if="
          expense &&
          expense.fare &&
          expense.fare.pending &&
          expense.fare.pending > 0 &&
          expense.vendor_id
        "
      >
        <tr>
          <td colspan="5" style="text-align: right">
            Pending: {{expense.fare.pending}}
          </td>
          <td colspan="2" style="text-align: right">
            <z-payment-done-create
              color="blue"
              x-small
              :vendor_id="expense ? expense.vendor_id : null"
              :entity_id="expense.billingEntity_id"
              :fare="expense ? expense.fare : null"
              :date="dateComputed"
              :expense="expense"
              btn
              :hideBills="true"
              @reload="reload"
            >
              <v-btn color="purple lighten-3" x-small>
                {{ $i18n.t("Add Payment") }}
              </v-btn>
            </z-payment-done-create>
          </td>
        </tr>
      </tfoot>
    </v-simple-table>
  </v-card>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import { Vue, Component } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "SupplierPayment",
  components: {},
  props: {
    expense: {
      default: null,
    },
    hideBills: {
      default: null,
    },
    hideExpenses: {
      default: null,
    },
    label: {
      default: "Supplier Payments",
    },
  },
})
export default class SupplierPayment extends Vue {
  dateComputed = null;
  payments = [];

  async fetchPayments() {
    if (this.expense && this.expense._id) {
      const payments = await doGet(
        "/api/paymentmade/expense/" +
          this.expense._id +
          "/payments?vendor_id=" +
          this.expense.vendor_id
      );
      this.payments = payments;
      if (payments && payments.length > 0) {
        this.$emit("setVendorDisable", true);
      }
    }
  }

  get loading() {
    return common.loading;
  }

  async deletePayment(paymentmade_id) {
    common.setLoading(true);
    try {
      await doGet("/api/paymentmade/" + paymentmade_id + "/delete");
      common.showMessage("Deleted Successfully");
      this.fetchPayments();
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    await this.fetchPayments();
    this.dateComputed = this.expense.date;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reload(reload) {
    if (reload) {
      this.fetchPayments();
      this.$emit("reload", this.expense);
    }
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
